import React from 'react';

export const ConstructionPlanFormModelReferenceHint = () => (
    <div className="construction-plan-form__edit-hint">
        Konfiguration beibehalten (keine Bearbeitung möglich)
    </div>
);

export default ConstructionPlanFormModelReferenceHint;
